export default __webpack_public_path__ + "static/media/self-picture2.a8eb3955.jpg";